var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 16.5411C11.587 16.5411 11.251 16.2051 11.251 15.7911V3.75012C11.251 3.33612 11.587 3.00012 12.001 3.00012C12.415 3.00012 12.751 3.33612 12.751 3.75012V15.7911C12.751 16.2051 12.415 16.5411 12.001 16.5411Z",
    fill: "#130F26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 16.541C11.8018 16.541 11.6098 16.462 11.4698 16.32L8.55383 13.393C8.26183 13.099 8.26283 12.624 8.55583 12.332C8.84983 12.04 9.32383 12.04 9.61583 12.334L12.0008 14.729L14.3858 12.334C14.6778 12.04 15.1518 12.04 15.4458 12.332C15.7388 12.624 15.7398 13.099 15.4478 13.393L12.5318 16.32C12.3918 16.462 12.1998 16.541 12.0008 16.541Z",
    fill: "#130F26"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 20,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.73267H21.9998V21.4767H2V7.73267Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.575 21.4767H6.435C3.99 21.4767 2 19.4877 2 17.0417V12.1567C2 9.71667 3.985 7.73267 6.426 7.73267H7.367C7.781 7.73267 8.117 8.06867 8.117 8.48267C8.117 8.89667 7.781 9.23267 7.367 9.23267H6.426C4.812 9.23267 3.5 10.5437 3.5 12.1567V17.0417C3.5 18.6607 4.816 19.9767 6.435 19.9767H17.575C19.187 19.9767 20.5 18.6637 20.5 17.0517V12.1677C20.5 10.5487 19.183 9.23267 17.566 9.23267H16.634C16.22 9.23267 15.884 8.89667 15.884 8.48267C15.884 8.06867 16.22 7.73267 16.634 7.73267H17.566C20.011 7.73267 22 9.72267 22 12.1677V17.0517C22 19.4917 20.014 21.4767 17.575 21.4767Z",
    fill: "#130F26"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.02dcdbfc.svg";
export { ForwardRef as ReactComponent };